// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"5dfa2387","821":"22de80fe"}[chunkId] + ".chunk.js");